import { useMemo } from "react"
import { useQuery } from "@tanstack/react-query"
import { QueryRender } from "@/components/helpers/QueryRender"
import { useGlobalSettings } from "@/entities/globalSettings/useGlobalSettings"
import { getDayQuarters } from "@/entities/globalSettings/globalSettings"
import { computeAttendanceForQuarters } from "@/controller/attendanceCompute"
import { AttendanceStatus } from "@/types/attendanceStatus"
import { icon_external, icon_mini_check } from "@/utils/svgIcons"

interface Props {
   youngId: string
   day: Date
   schoolyearId: string
}

export function IndividualAttendanceMiniDay({ youngId, day, schoolyearId }: Props) {
   const { data: globalSettings } = useGlobalSettings()

   const dayQuarters = useMemo(
      () => (globalSettings ? getDayQuarters(globalSettings, day) : []),
      [day, globalSettings],
   )

   const getQuarterColor = (status: AttendanceStatus) => {
      switch (status) {
         case "present":
            return "bg-success"
         case "absent":
            return "bg-error"
         case "late":
            return "bg-warning"
         case "external":
            return "bg-neutral-content"
         default:
            return "bg-base-300"
      }
   }

   const { data: quarterStatuses = {}, ...query } = useQuery({
      queryKey: [
         "collection",
         "attendance_events",
         "statistics",
         youngId,
         schoolyearId,
         day.toISOString(),
      ],
      queryFn: async () => computeAttendanceForQuarters({
         youngId,
         day,
         schoolyearId,
         dayQuarters,
         globalSettings,
      }),
      enabled: !!schoolyearId && !!globalSettings,
   })

   return (
      <QueryRender query={query} data={quarterStatuses}>
         {() => (
            <div className="flex gap-1">
               {dayQuarters.map((_, index) => {
                  const key = `${day.toISOString()}-${index}`
                  const status = quarterStatuses[key]?.status || "unknown"
                  return (
                     <div
                        key={key}
                        className={`w-1/4 h-6 rounded-full ${getQuarterColor(status)} flex justify-center items-center text-white text-xs font-bold`}
                        // title={`${status}${quarterStatuses[key]?.justified ? " (justified)" : ""}`}
                     >
                        {["late", "absent"].includes(status) &&
                           quarterStatuses[key]?.justified &&
                           icon_mini_check}
                        {status === "external" && icon_external}
                     </div>
                  )
               })}
            </div>
         )}
      </QueryRender>
   )
}
